// ---------------------------------------------------------------------------
// Webpack public path override for embedded (MFE) mode
// ---------------------------------------------------------------------------
// When sandbox runs inside portal, webpack's chunk loader constructs URLs for
// lazy-loaded chunks relative to publicPath. By default this is "/" which
// resolves to portal's origin (e.g. localhost:3002), causing 404s for sandbox
// chunks. Override it to sandbox's own origin so chunks load correctly.
//
// This file MUST be imported before any other module that triggers code
// splitting or asset loading (import it first in index.js).
// ---------------------------------------------------------------------------
if (window.__SANDBOX_IS_PLUGIN__ && window.__SANDBOX_PUBLIC_PATH__) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.__SANDBOX_PUBLIC_PATH__;
}
